import Button from 'components/features/pfm/Button/Button'
import Flex from 'components/atoms/Flex/Flex'
import { IS_MOBILE } from 'helpers/userAgentHelpers'
import { FC, ReactNode, useState } from 'react'
import SwipeableViews from 'react-swipeable-views'

type VariantsContext = {
  variants: Array<ReactNode>
  setCurrentVariantIndex: (index: number) => void
  currentVariantIndex: number
}
type UseVariantsResult = {
  /** The props you should spread on to Variants and Variant Buttons */
  variantsContext: VariantsContext
  /** Your variants wrapped in a swipeable view that can be controlled by the VariantButtons */
  Variants: FC<VariantsContext>
  /** Controls which variant is visible */
  VariantButtons: FC<VariantsContext>
}

export function useVariants (variants: Array<ReactNode>, defaultVariant = 1): UseVariantsResult {
  const [currentVariantIndex, setCurrentVariantIndex] = useState(defaultVariant - 1) // Subtract because its an array index

  return {
    Variants,
    VariantButtons,
    variantsContext: {
      variants,
      setCurrentVariantIndex,
      currentVariantIndex,
    },
  } as UseVariantsResult
}

export const Variants: FC<VariantsContext> = (props) => {
  const { currentVariantIndex, setCurrentVariantIndex, variants } = props

  if (!IS_MOBILE) {
    return <>{ variants[currentVariantIndex] }</>
  }

  return (
    <SwipeableViews onChangeIndex={ setCurrentVariantIndex } index={ currentVariantIndex } animateHeight ignoreNativeScroll>
      { variants }
    </SwipeableViews>
  )
}

export const VariantButtons: FC<VariantsContext> = (props) => {
  const { currentVariantIndex, setCurrentVariantIndex, variants } = props
  return (
    <Flex gap='tiny' horizontal alignRight>
      {
        variants.map((_variant, idx) => (
          <Button
            key={ idx }
            text={ (idx + 1).toString() }
            onClick={ () => setCurrentVariantIndex(idx) }
            disabled={ idx === currentVariantIndex }
            size='mini'
            style='textOnly'
          />
        ))
      }
    </Flex>
  )
}
